module.exports = __webpack_public_path__ + "assets/img/signUp.7823c7fa.png";